export default __webpack_public_path__ + "static/media/ddf04544b44793d7.2b1d235a63dd73c36d86f87b85c98317.svg";